import { render } from "./px-edit-panel.vue?vue&type=template&id=23fcb92d&scoped=true&ts=true"
import script from "./px-edit-panel.vue?vue&type=script&lang=ts"
export * from "./px-edit-panel.vue?vue&type=script&lang=ts"

import "./px-edit-panel.vue?vue&type=style&index=0&id=23fcb92d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fcb92d"]])

export default __exports__